import React from "react";
import { Star } from "lucide-react";

/**
 * Sélecteur d'étoiles 1-5.
 * - `value` : note actuelle (0-5)
 * - `onChange` : callback si interactif (sinon composant read-only)
 * - `size` : taille des étoiles en pixels (defaut 24)
 * - `readOnly` : désactive le clic + hover
 * - `data-testid` : préfixe pour les étoiles (chaque bouton = `${testid}-${n}`)
 */
export default function RatingStars({
  value = 0,
  onChange,
  size = 24,
  readOnly = false,
  "data-testid": testid = "rating-star",
  ariaLabel = "Note",
}) {
  const [hover, setHover] = React.useState(0);
  const active = hover || value;

  if (readOnly) {
    return (
      <div className="inline-flex items-center gap-0.5" aria-label={ariaLabel}>
        {[1, 2, 3, 4, 5].map((n) => (
          <Star
            key={n}
            size={size}
            className={n <= active ? "text-[#E8710A] fill-[#E8710A]" : "text-[#CBD5E1]"}
          />
        ))}
      </div>
    );
  }

  return (
    <div
      className="inline-flex items-center gap-1"
      onMouseLeave={() => setHover(0)}
      role="radiogroup"
      aria-label={ariaLabel}
    >
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => onChange?.(n)}
          onMouseEnter={() => setHover(n)}
          data-testid={`${testid}-${n}`}
          aria-label={`${n} sur 5`}
          aria-checked={value === n}
          role="radio"
          className={`transition-transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-[#1B3A5C] rounded ${
            n <= active ? "text-[#E8710A]" : "text-[#CBD5E1] hover:text-[#E8710A]/60"
          }`}
        >
          <Star size={size} className={n <= active ? "fill-[#E8710A]" : ""} />
        </button>
      ))}
    </div>
  );
}
